import App from '../App';
import $ from 'jquery';

const Utility = new class
{
    serializedArrayToObject(serializedArray)
    {
        var assocObject = {};

        for (let i = 0; i < serializedArray.length; i++) {
            let data = serializedArray[i];
            let arrayData = data.name.match(/\[\]$/g);
            let key = data.name;

            if (arrayData) {
                key = key.replace(/\[\]$/g, '');
            }

            if (!assocObject[key]) {
                assocObject[key] = arrayData ? [] : null;
            }

            if (arrayData) {
                assocObject[key].push(data.value);
            } else {
                assocObject[key] = data.value;
            }
        }

        return assocObject;
    }

    getURLParameter(sParam)
    {
        const sPageURL = window.location.search.substring(1);
        const sURLVariables = sPageURL.split('&');
        for (let i = 0; i < sURLVariables.length; i++) {
            let sParameterName = sURLVariables[i].split('=');
            if (sParameterName[0] == sParam) {
                sParameterName[1] = sParameterName[1].replace('+', ' ');
                return decodeURIComponent(sParameterName[1]);
            }
        }
    }

    waitForDefined(checkCallback, limit = 1000)
    {
        return new Promise((resolve, reject) => {
            let iteration = 0;

            let interval = setInterval(() => {
                ++iteration;

                let defined = checkCallback();

                if (typeof defined !== 'undefined') {
                    clearInterval(interval);
                    resolve(defined);
                } else if (iteration >= limit) {
                    clearInterval(interval);
                    reject();
                }
            });
        });
    }

    maxZ(not)
    {
        var zMax = 2000000000;

        return Math.max.apply(null, $.map($('body *'), function(e, n) {

            if (not) {
                if ($(e).filter(not).length) {
                    return 0;
                }
            }

            if ($(e).css('position') != 'static') {
                var z = parseInt($(e).css('z-index')) || 1;
            }

            /**
             * Disallow z-indexes over 2 billion. Lots of
             * third-party vendors use the max z-index
             * to ensure their widgets are always on
             * top. We will reset them down to 2
             * billion to ensure Jonah menus
             * and lightboxes can always be
             * on top.
             */
            if (z >= zMax) {
                z = zMax;
                $(e).css('z-index', z);
            }

            return z;
        }));
    }

    lockBody(withClass = null)
    {
        $('body').data('lock-with-class', withClass).data('original-scrolltop', $(window).scrollTop()).css({
            position: 'fixed',
            top: ($(window).scrollTop() * -1) + 'px',
            left: 0,
            width: '100%',
        }).data('body-locked', 1);

        if (withClass) {
            $('body').addClass(withClass);
        }
    }

    releaseBody()
    {
        $('body').css({
            position: '',
            top: '',
            left: '',
            width: '',
        }).data('body-locked', 0);

        if ($('body').data('lock-with-class')) {
            $('body').removeClass($('body').data('lock-with-class'));
        }

        $(window).scrollTop($('body').data('original-scrolltop'));
    }

    bodyIsLocked()
    {
        return $('body').data('body-locked') === 1;
    }

    scrollToElementTop(elementOrSelector, smooth = true)
    {
        let $element = $(elementOrSelector);

        if ($element.length) {
            let topOffset = $element.offset().top;

            App.stickyHeader().then((StickyHeader) => {
                this.#doScrollAction(topOffset, StickyHeader, smooth);
            });
        }
    }

    scrollToElementBottom(elementOrSelector, smooth = true)
    {
        let $element = $(elementOrSelector);

        if ($element.length) {
            let topOffset = $element.outerHeight() + $element.offset().top;

            App.stickyHeader().then((StickyHeader) => {

                console.log(topOffset);
                this.#doScrollAction(topOffset, StickyHeader);
            });
        }
    }

    #doScrollAction(topOffset, StickyHeader = null)
    {
        let scrollInt = null;

        if (StickyHeader) {
            scrollInt = setInterval(() => {
                if (StickyHeader.visible) {
                    clearInterval(scrollInt);
                    topOffset = topOffset - StickyHeader.height();

                    $('html, body').stop().animate({ scrollTop: topOffset }, () => {
                        clearInterval(scrollInt);
                    });
                }
            }, 4);
        }

        $('html, body').animate({ scrollTop: topOffset }, () => {
            clearInterval(scrollInt);
        });
    }

    mayUseStorage()
    {
        try {
            localStorage.use_storage = 1;
            return true;
        } catch (e) {
            return false;
        }
    }

    /**
     * Observe one or more elements and trigger a callback when they enter the viewport.
     * Uses IntersectionObserver with an optional rootMargin. Falls back to a scroll listener.
     *
     * @param {Element|jQuery|NodeList|Array<Element>} targets
     * @param {Function} callback Receives (element, entry)
     * @param {Object|number|string} options Options for IntersectionObserver or a rootMargin value. Example: { rootMargin: '100px 0px', threshold: 0 }
     * @returns {Function} unobserve function to stop observing all provided targets
     */
    elementInViewport(targets, callback, options = {})
    {
        // Normalize targets to an array of Elements
        let elements = [];
        if (!targets) {
            return () => {};
        }
        if (typeof jQuery !== 'undefined' && targets instanceof jQuery) {
            elements = targets.get();
        } else if (NodeList.prototype.isPrototypeOf(targets) || Array.isArray(targets)) {
            elements = Array.from(targets);
        } else {
            // assume single element or selector
            elements = $(targets).get();
        }

        // Normalize options/rootMargin convenience
        let ioOptions = { root: null, threshold: 0, rootMargin: '0px' };
        if (typeof options === 'number') {
            ioOptions.rootMargin = options + 'px 0px';
        } else if (typeof options === 'string') {
            ioOptions.rootMargin = options;
        } else if (options && typeof options === 'object') {
            ioOptions = Object.assign(ioOptions, options);
        }

        // If no callback provided, provide a no-op to keep signature simple
        const cb = typeof callback === 'function' ? callback : function() {};

        // IntersectionObserver path
        const observed = new Set();
        let observer = null;

        if ('IntersectionObserver' in window) {
            observer = new IntersectionObserver((entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting || entry.intersectionRatio > 0) {
                        cb(entry.target, entry);
                        if (observer) {
                            observer.unobserve(entry.target);
                        }
                        observed.delete(entry.target);
                    }
                });
            }, ioOptions);

            elements.forEach((el) => {
                if (el && el.nodeType === 1) {
                    observed.add(el);
                    observer.observe(el);
                }
            });

            // Return unobserve function
            return () => {
                if (observer) {
                    observed.forEach((el) => observer.unobserve(el));
                    observer.disconnect();
                }
                observed.clear();
            };
        }

        // Fallback: check on scroll/resize with bounding rect and margin
        const margin = (function() {
            if (typeof options === 'number') {
                return options;
            }
            if (typeof options === 'string') {
                return parseInt(options, 10) || 0;
            }
            if (options && typeof options.rootMargin === 'string') {
                const m = parseInt(options.rootMargin, 10);
                return isNaN(m) ? 0 : m;
            }
            return 0;
        })();

        const handler = () => {
            elements.forEach((el) => {
                if (!el || el.__pp1_loaded) {
                    return;
                }
                const rect = el.getBoundingClientRect();
                const within =
                    rect.top <= (window.innerHeight || document.documentElement.clientHeight) + margin &&
                    rect.bottom >= -margin &&
                    rect.left <= (window.innerWidth || document.documentElement.clientWidth) + margin &&
                    rect.right >= -margin;
                if (within) {
                    el.__pp1_loaded = true;
                    cb(el, null);
                }
            });
        };

        handler();
        window.addEventListener('scroll', handler, { passive: true });
        window.addEventListener('resize', handler);

        // Return cleanup
        return () => {
            window.removeEventListener('scroll', handler);
            window.removeEventListener('resize', handler);
        };
    }

    fancyboxSettings()
    {
        return {
            idleTime: 60,
            loop: true,
            transitionEffect: 'slide',

            buttons: [
                'close',
            ],

            wheel: false,

            beforeLoad: () => {
                $('.fancybox-container').css('z-index', this.maxZ() + 1);
            },

            beforeShow: (instance) => {
                let $trigger = instance.group[instance.currIndex].opts.$orig;

                if ($trigger.data('as-video')) {
                    instance.$refs.stage.addClass('video');
                }
            },

            afterLoad : function(instance, current) {
                var $thumb = instance.group[instance.currIndex].$thumb;
                if (current.type == 'image' && $thumb && $thumb.length) {
                    current.$image.attr('alt', $thumb.attr('alt')).attr('title', $thumb.attr('title'));
                }

            },

        };
    }

    maxZ(not)
    {
        let zMax = 2000000000;

        return Math.max.apply(
            null,
            $.map($('body *'), function(e, n) {

                if (not) {
                    if ($(e).filter(not).length) {
                        return 0;
                    }
                }

                if ($(e).css('position') != 'static') {
                    let z = parseInt($(e).css('z-index')) || 1;

                    /**
                     * Disallow z-indexes over 2 billion. Lots of
                     * third-party vendors use the max z-index
                     * to ensure their widgets are always on
                     * top. We will reset them down to 2
                     * billion to ensure Jonah menus
                     * and lightboxes can always be
                     * on top.
                     */
                    if (z >= zMax) {
                        z = zMax;
                        $(e).css('z-index', z);
                    }

                    return z;
                }
            }),
        );
    }

    getOffset($element)
    {
        let offset = Math.ceil($element.offset().top);

        if (jcms.settings.stickyNav) {
            if (jcms.settings.stickyNav == 'desktop_only' && $(window).width() <= 808) {
                return offset;
            } else {
                offset = $('#sticky-header').length ? Math.ceil(offset - $('#sticky-header').outerHeight()) : offset;
            }
        }

        return offset;
    }

    scriptLoader(deferredScripts)
    {
        if (deferredScripts && typeof $ != 'undefined') {
            if (deferredScripts.head && Array.isArray(deferredScripts.head) && deferredScripts.head.length) {
                $('head').append(deferredScripts.head.join(''));
            }

            if (deferredScripts.body && Array.isArray(deferredScripts.body) && deferredScripts.body.length) {
                deferredScripts.body.forEach(function(script) {
                    $('body').prepend(deferredScripts.body.join(''));
                });
            }

            if (deferredScripts.footer && Array.isArray(deferredScripts.footer) && deferredScripts.footer.length) {
                deferredScripts.footer.forEach(function(script) {
                    $('body').append(deferredScripts.footer.join(''));
                });
            }
        }
    }
};

export default Utility;
